import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import MuiInputTextWithRemainingChars from '@shared/components/MuiInputTextWithRemainingChars';

const RETURN_NOTES_MAX_LENGTH = 5000;
const PLACEHOLDER_TEXT = 'Describe requested changes for the appraisal details.';

const EventReturnDialogContent = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <div className='dialog-content-field-wrapper'>
      <div className='input-area'>
        <div className='label bold'>Comment*</div>
        <Controller
          control={control}
          name='returnNotes'
          render={({ field }) => (
            <MuiInputTextWithRemainingChars
              name='returnNotes'
              className='value'
              error={!!errors.returnNotes}
              disableUnderline
              multiline
              rows={5}
              value={field.value}
              onChange={field.onChange}
              maxLength={RETURN_NOTES_MAX_LENGTH}
              hideRemainingChars={false}
              placeholder={PLACEHOLDER_TEXT}
            />
          )}
        />
      </div>
    </div>
  );
};

export default EventReturnDialogContent;
